import PropTypes from "prop-types";

const NavButton = ({ children, onClick, selected }) => (
  <button
    className={`${
      selected
        ? "tw-bg-theme-primary-alternative tw-text-white tw-shadow-[0px_2px_8px_0px_rgba(191,191,191,0.80)]"
        : "tw-bg-transparent hover:tw-bg-tinted-gray-50 tw-text-gray-50 active:tw-bg-theme-primary-alternative active:tw-text-white active:tw-shadow-[0px_2px_8px_0px_rgba(191,191,191,0.80)]"
    } tw-transition-all tw-border-none tw-px-[20px] tw-py-[8px] tw-rounded-full tw-text-16d tw-font-semibold`}
    onClick={onClick}
    type="button"
  >
    {children}
  </button>
);

NavButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
};

NavButton.defaultProps = {
  selected: false,
};

const NavButtons = ({ onChange, options, value }) => (
  <div className="tw-z-2 tw-flex tw-gap-[8px] tw-sticky tw-top-[12px] tw-mx-auto tw-py-[10px] tw-px-[12px] tw-rounded-full tw-border-solid tw-border-[1px] tw-border-gray-10 tw-bg-frosted-glass tw-backdrop-blur-sm tw-shadow-[-3px_11px_41px_0px_rgba(159,159,159,0.15)]">
    {options.map((option) => (
      <NavButton key={option} selected={value === option} onClick={() => onChange(option)}>
        {option}
      </NavButton>
    ))}
  </div>
);

NavButtons.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string.isRequired,
};

export default NavButtons;
